/** Calls the native `toLowerCase`, but wraps it for TypeScript to assure the change in case for literal strings. */
export function toLowerCase<T extends string>(value: T) {
  return value.toLowerCase() as Lowercase<T>;
}
